import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const daTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Navn (små bogstaver, ingen specialtegn)',
    add: 'Tilføj',
    allowedFileTypes: 'Tilladte filtyper',
    allowedFileTypesDescription:
      'Begræns tilladte filtyper (f.eks. image/*, program/pdf). Lad være tomt for at tillade alle typer.',
    allowMultipleFiles: 'Tillad flere filer',
    amountInCents: 'Beløb i cents',
    basePrice: 'Grundpris',
    bcc: 'BCC',
    brand: 'Mærke',
    cc: 'CC',
    checkboxPlural: 'Afkrydsningsfelter',
    checkboxSingular: 'Afkrydsningsfelt',
    checkedByDefault: 'Markeret som standard',
    chooseConfirmationType:
      'Vælg, om du vil vise en meddelelse på siden eller omdirigere til en anden side, efter de har indsendt formularen.',
    condition: 'Tilstand',
    confirmationMessage: 'Bekræftelsesmeddelelse',
    confirmationType: 'Bekræftelsestype',
    countryPlural: 'Landefelter',
    countrySingular: 'Land',
    creditCard: 'Kreditkort',
    customURL: 'Brugerdefineret URL',
    datePlural: 'Dato felter',
    dateSingular: 'Dato',
    defaultValue: 'Standardværdi',
    divide: 'Del',
    documentToLinkTo: 'Dokument at linke til',
    doesNotEqual: 'Er ikke ens',
    emailFrom: 'E-mail fra',
    emailPlural: 'E-mail felter',
    emailsDescription:
      'Send tilpassede e-mails, når formularen indsendes. Brug kommaseparerede lister til at sende den samme e-mail til flere modtagere. For at henvise til en værdi fra denne formular skal du ombryde feltets navn med dobbelte krøllede parenteser, dvs. {{firstName}}. Du kan bruge et jokertegn {{*}} til at udlæse alle data og {{*:table}} til at formatere det som en HTML-tabel i e-mailen.',
    emailSingular: 'E-mail',
    emailTo: 'E-mail til',
    equals: 'Lige til',
    field: 'Felt',
    fields: 'Felter',
    fieldWidth: 'Feltbredde (procent)',
    hasAnyValue: 'Har enhver værdi',
    internalLink: 'Internt link',
    label: 'Etiket',
    maxFileSize: 'Maks. filstørrelse (bytes)',
    maxFileSizeDescription: 'Maksimal filstørrelse i bytes. Lad være tomt uden grænse.',
    message: 'Besked',
    messageDescription: 'Indtast den besked, der skal sendes i denne e-mail.',
    messagePlural: 'Meddelelsesblokke',
    messageSingular: 'Besked',
    mimeType: 'MIME-type',
    mimeTypePlural: 'MIME-typer',
    mimeTypeSingular: 'MIME-type',
    multiply: 'Multiplicer',
    numberPlural: 'Nummer felter',
    numberSingular: 'Nummer',
    optionPlural: 'Valgmuligheder',
    optionSingular: 'Mulighed',
    paymentFieldPlural: 'Betalingsfelter',
    paymentFieldSingular: 'Betaling',
    paymentProcessor: 'betalingsbehandler',
    paymentStatus: 'Status',
    placeholder: 'Pladsholder',
    priceConditions: 'Prisbetingelser',
    priceConditionsPlural: 'Prisbetingelser',
    priceConditionsSingular: 'Pris Tilstand',
    radioOptions: 'Valgmuligheder for radioattribut',
    radioPlural: 'Radiofelter',
    radioSingular: 'Radio',
    redirect: 'Omdirigere',
    replyTo: 'Svar til',
    required: 'Påkrævet',
    selectOptions: 'Vælg Indstillinger',
    selectPlural: 'Vælg felter',
    selectSingular: 'Vælg',
    statePlural: 'Statsfelter',
    stateSingular: 'stat',
    staticValue: 'Statisk værdi',
    subject: 'Emne',
    submitButton: 'Indsend knaplabel',
    subtract: 'Træk fra',
    textareaPlural: 'Tekstområde felter',
    textareaSingular: 'Tekstområde',
    textPlural: 'Tekstfelter',
    textSingular: 'Tekst',
    title: 'Titel',
    token: 'token',
    uploadCollection: 'Upload samling',
    uploadCollectionDescription: 'Vælg, hvilken uploadsamling der skal gemmes filer i',
    uploadFieldPlural: 'Upload felter',
    uploadFieldSingular: 'Upload',
    urlToRedirectTo: 'URL at omdirigere til',
    value: 'Værdi',
    valueOfField: 'Værdi af felt',
    valueType: 'Værditype',
  },
}

export const da: PluginLanguage = {
  dateFNSKey: 'da',
  translations: daTranslations,
}
